<template>
	<BasicBanner :dismissal-key="dismissalKey" data-context="VCX banner">
		<p class="mr-200 balance-text"
			>{{ bannerText }}
			<BaseLink class="text-color-white text-decoration-underline font-weight-bold" :link="learnMoreLink"
				>Learn&nbsp;more</BaseLink
			></p
		>
	</BasicBanner>
</template>

<script setup lang="ts">
import BasicBanner from '@components/layout/basic-banner.vue';
import { Link } from 'types/layout';

const dismissalKey = 'dismiss-vcx-banner';

const bannerText =
	'We are taking the Fundrise Innovation Fund public on the New York Stock Exchange under the ticker VCX.';

const learnMoreLink: Link = {
	text: 'Learn more',
	router: 'vcx-landing'
};
</script>
<style scoped>
.balance-text {
	text-wrap: balance;
	-webkit-text-wrap: balance;
}
</style>
